<template>
  <div id="LocationView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title"> Location View </div>
            <div class="btn-groups text-right">
              <router-link v-if="canAddLocation == true" class="btn btn-primary"
              v-bind:to="{ name: 'LocationEdit', params: { id: locationId } }">
              <i class="fp-edit-icon"></i> Edit
            </router-link>
              <router-link v-if="canViewLocation == true" class="btn btn-secondary"
                v-bind:to="{ name: 'LocationList' }"> <i class="fp-back"></i> Back</router-link>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content customer-credit-detail list-view">
            <section class="internal-container">
              <div id="tabs" class="containerTab mt-3">
                <div class="tabs">
                  <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Location Details</a>
                  <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
                </div>
                <div class="content">
                  <div v-show="activetab === 1" class="tabcontent">
                    <div class="list-sections">
                      <div class="form-row no-divider">
                        <div class="col-md-6">
                            <div class="row form-group">
                              <label class="col">Location Code :</label>
                              <span class="col">{{ titleCase(locationData.code) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Location Name :</label>
                              <span class="col">{{ titleCase(locationData.company_name) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Phone :</label>
                              <span class="col">{{ titleCase(locationData.phone) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Bay :</label>
                              <span class="col">{{ titleCase(locationData.bay_count) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Email :</label>
                              <span class="col">{{ titleCase(locationData.email) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Location Link :</label>
                              <span class="col">{{ titleCase(locationData.location_link) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Address 1 :</label>
                              <span class="col">{{ titleCase(locationData.address_line_1) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Address 2 :</label>
                              <span class="col">{{ titleCase(locationData.address_line_2) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Is Rental: </label>
                              <span class="col" v-if="locationData.is_rental == 1">Yes</span>
                              <span class="col" v-else>No</span>
                            </div>
                            <div class="row form-group">
                                <label class="col">Is Job: </label>
                                <span class="col" v-if="locationData.is_job == 1">Yes</span>
                                <span class="col" v-else>No</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row form-group">
                              <label class="col">State :</label>
                              <span class="col">{{ titleCase(locationData.state) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">City :</label>
                              <span class="col">{{ titleCase(locationData.city) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Zip :</label>
                              <span class="col">{{ titleCase(locationData.zip) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Mobile :</label>
                              <span class="col">{{ titleCase(locationData.mobile) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Description :</label>
                              <span class="col">{{ titleCase(locationData.description) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Timezone :</label>
                              <span class="col">{{ titleCase(locationData.tzName) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">AFT :</label>
                              <span class="col">{{ titleCase(locationData.aft) }}</span>
                            </div>
                            <div class="row form-group">
                              <label class="col">Diesel Tax :</label>
                              <span class="col">{{ titleCase(locationData.diesel_tax) }}</span>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs">
                    <location-activity-log-list :activityLogVal="activityLogsTabValue"></location-activity-log-list>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
            <div class="error-template">
              <h1>Oops!</h1>
              <h2>403</h2>
              <div class="error-details">Sorry!, You don't have permission to access this page.</div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from "../mixins/commonMixins";

import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("location-activity-log-list", ActivityLogListView);

export default {
  name: "LocationView",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Location View | " +process.env.COPYRIGHT_NAME
  },
  mixins: [commonMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    canAddLocation : false,
    canViewLocation : false,
    loading: false,
    activetab: 1,
    activityLogsTabValue: "dontLoadList",
    locationData : "",
    locationId: 0,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == "view_location") {
            self.cantAccessPage = true;
            self.canViewLocation = true;
          }
          if (permissions[i].name == "add_location") {
            self.canAddLocation = true;
          }

        }
      }
    }
  },
  mounted: function () {

    var self = this;
    var path = window.location.pathname;
    var segments = path.split("/");
    self.locationId = segments[3];

    self.loadLocationView();
    self.getPermissions();


  },
  methods: {
    loadLocationView(){
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;

      $.ajax({
        url: process.env.ROOT_API + "/location/"+ segments[3],
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          if (data.status == "success") {
            self.loading = false;
            console.log(data.content);
            self.locationData = data.content;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          setTimeout(function () {
            self.generateStatusCodeMessage(jqXHR, false, 'location-view-page')
          }, 500);


        }
      });
    },
    activityLogs() {

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      self.$root.$emit('activity_log_opted', 'location', segments[3]);
      self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      self.activetab = 2;
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/LocationView.vue